'use client';

import type { FC } from 'react';
import { ScreenContent, ScreenFixedTop, ScreenTabBar } from '../../screen';
import { useLocalTranslation } from '../../hooks/useLocalTranslation';
import { InfoCard } from '../../components/ui/InfoCard';
import translations from './DigitalContentScreen.translations';

export const DigitalContentScreen: FC = () => {
  const { t } = useLocalTranslation(translations);

  const items = [t('item1'), t('item2'), t('item3'), t('item4'), t('item5'), t('item6')];

  return (
    <>
      <ScreenFixedTop title={t('navTitle')} />
      <ScreenTabBar />
      <ScreenContent>
        <div className="mx-auto flex max-w-2xl flex-col gap-4 p-4 pb-8">
          <InfoCard>
            <h2 className="m-0 mb-3 text-base font-bold text-white">{t('title')}</h2>
            <ol className="m-0 flex list-decimal flex-col gap-2 ps-5">
              {items.map((item, i) => (
                <li key={i} className="text-sm leading-normal text-[rgb(209,213,219)]">
                  {item}
                </li>
              ))}
            </ol>
          </InfoCard>
        </div>
      </ScreenContent>
    </>
  );
};
